<template>
<v-card outlined class="bg_none">
    <v-card-title class="text-primary text-center text-h5 font-weight-black">ACCIONES</v-card-title>
    <v-divider></v-divider>
    <v-card-actions class="text-center">
        <v-spacer></v-spacer>
        <v-btn color="primary" depressed @click="form.restart = true; setStatus()" :loading="loading" :disabled="loading">Reiniciar</v-btn>
        <v-btn color="error" v-if="this.form.available" @click="form.available = false; setStatus()" depressed :loading="loading" :disabled="loading">Deshabilitar</v-btn>
        <v-btn color="success" v-if="!this.form.available" @click="form.available = true; setStatus()" depressed :loading="loading" :disabled="loading">Habilitar</v-btn>
        <v-spacer></v-spacer>
    </v-card-actions>
</v-card>
</template>

<script>
import ApiService from '../../../libs/apiService';
export default {
    name: 'Actions',
    props: ['id'],
    data() {
        return {
            form: {
                piggybank_id: null,
                available: false,
                restart: false
            },
            loading: false
        }
    },
    methods: {
        async getStatus() {
            this.loading = true;
            const apiService = new ApiService();
            const req = {
                piggybank_id: this.id
            };
            apiService.post('/piggybank/externalorders/get', req, true).then((res) => {
                this.loading = false;
                if (res) {
                    const data = JSON.parse(res);
                    this.form.available = data.available;
                    this.form.restart = data.restart;
                }
            }).catch((err) => {
                this.loading = false;
                console.log(err);
            });
        },
        async setStatus() {
            this.loading = true;
            const apiService = new ApiService();
            const req = this.form;
            apiService.post('/piggybank/externalorders/set', req, true, true).then((res) => {
                this.loading = false;
                if (res) {
                    if (res.status === 200) {
                        this.$store.dispatch("setAlert", {
                            show: true,
                            msg: 'La acción se ejecutó exitosamente',
                            color: 'success'
                        });
                    }
                }
            }).catch(() => {
                this.loading = false;
                this.$store.dispatch("setAlert", {
                    show: true,
                    msg: 'Hubo un error, por favor vuelve a intentar',
                    color: 'error'
                });
            });
        }
    },
    mounted() {
        setTimeout(() => {
            this.getStatus();
            this.form.piggybank_id = this.id;
        }, 100);
    },
}
</script>
